export const statusColors: { [key: string]: string } = {
  active: 'bg-electricBlue',
  sold: 'bg-brightRed',
  canceled: 'bg-brightCoral',
}
